import type {State} from 'src/reducers';


export const selectI18NSelectedLanguage = (state: State): string =>
  // @ts-expect-error - TS2339 - Property 'i18NSelectedLanguage' does not exist on type 'DefaultRootState'.
  state.agentSettings.i18NSelectedLanguage;
